   document.addEventListener("DOMContentLoaded", function () {
    const query = new URLSearchParams(window.location.search).get('q');
    const page = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;
    if (query) {
      handleSearch(query, page);
    }
  });

  async function handleSearch(query, page = 1) {
    const customerTags = window.customerTags || [];
    if (customerTags.length === 0) {
      document.getElementById("results-container").innerHTML = "<p>You have no associated tags.</p>";
      return;
    }

    const perPage = 50; // Load enough results for frontend filtering
    const storefrontToken = 'cbe73c5c8f2afb71c4c072e2c4896d26'; // Replace this
    const endpoint = '/api/2023-10/graphql.json';

   
    const tagFilter = customerTags.map(tag => `tag:${tag}`).join(' OR ');
    const combinedQuery = `${query} AND (${tagFilter})`;

const graphqlQuery = `
  query SearchProducts($query: String!, $first: Int!, $after: String) {
    products(query: $query, first: $first, after: $after) {
      edges {
        node {
          title
          handle
          tags
          featuredImage {
            url
            altText
          }
          variants(first: 10) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;



    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({
          query: graphqlQuery,
          variables: {
            query: combinedQuery,
            first: perPage,
            after: null
          }
        })
      });

      const result = await response.json();

      if (result.errors) {
        console.error('GraphQL errors:', result.errors);
        return;
      }

      const allProducts = result.data.products.edges.map(edge => edge.node);

      // Paginate manually on frontend
      const start = (page - 1) * 10;
      const end = page * 10;
      const paginatedProducts = allProducts.slice(start, end);

      displayResults(paginatedProducts, page, query, allProducts.length);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  }

  function displayResults(products, page, query, totalCount) {
  const container = document.getElementById("results-container");
  const paginationContainer = document.getElementById("pagination");

  if (products.length > 0) {
    // Create the "X results for 'query'" header
    const headerHTML = `
      <div class="search-results-header">
        <h2>${totalCount} result${totalCount !== 1 ? 's' : ''} for “${query}”</h2>
      </div>
    `;

    // Generate product list HTML
    const resultsHTML = products.map(product => {
      const imageUrl = product.featuredImage?.url || '';
      const imageAlt = product.featuredImage?.altText || product.title;

      const variantEdges = product.variants?.edges || [];
      const prices = variantEdges.map(edge => parseFloat(edge.node.price.amount));
      const lowestPrice = prices.length > 0 ? Math.min(...prices) : null;

      return `
        <li class="list-view-item">
          <div class="product-card product-card--list">
            <a class="full-width-link" href="/products/${product.handle}">
              <span class="visually-hidden">${product.title}</span>
            </a>
            <div class="list-view-item__link">
              <div class="list-view-item__image-column">
                <div class="list-view-item__image-wrapper product-card__image-wrapper">
                  <img class="list-view-item__image" src="${imageUrl}" alt="${imageAlt}">
                </div>
              </div>
              <div class="list-view-item__title-column">
                <div class="list-view-item__title" aria-hidden="true">
                  <span class="product-card__title">${product.title}</span>
                </div>
              </div>
              <div class="list-view-item__price-column">
                <span class="price-item price-item--regular">
                  ${lowestPrice ? `from $${lowestPrice.toFixed(2)}` : 'Price unavailable'}
                </span>
              </div>
            </div>
          </div>
        </li>
      `;
    }).join('');

    container.innerHTML = `
      ${headerHTML}
      <ul class="search-results">${resultsHTML}</ul>
    `;
    displayPagination(page, query, totalCount);
  } else {
    container.innerHTML = `<p>No products found matching your tags.</p>`;
    paginationContainer.innerHTML = '';
  }
}


  function displayPagination(currentPage, query, totalCount) {
    const perPage = 10;
    const totalPages = Math.ceil(totalCount / perPage);
    const paginationContainer = document.getElementById("pagination");
    let html = '<ul class="pagination">';

    if (currentPage > 1) {
      html += `<li><a href="?q=${query}&page=${currentPage - 1}">Previous</a></li>`;
    }

    for (let i = 1; i <= totalPages; i++) {
      html += `<li><a href="?q=${query}&page=${i}" class="${i === currentPage ? 'active' : ''}">${i}</a></li>`;
    }

    if (currentPage < totalPages) {
      html += `<li><a href="?q=${query}&page=${currentPage + 1}">Next</a></li>`;
    }

    html += '</ul>';
    paginationContainer.innerHTML = html;
  }

